import { FormEvent, ReactElement, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { DealmakerCatalogResult } from "../../../Services/DealmakerCatalog";

interface DealmakerSearchFormProps {
  options: DealmakerCatalogResult["options"] | null;
}

export default function DealmakerSearchForm({ options }: DealmakerSearchFormProps): ReactElement {
  const [params, setParams] = useSearchParams();
  const formRef = useRef<HTMLFormElement>(null);
  const [words, setWords] = useState(params.get("words") || "");
  const [firmId, setFirmId] = useState(params.get("firmId") || "-99");
  const [jurisdiction, setJurisdiction] = useState(params.get("jurisdiction") || "-99");
  const [regionId, setRegionId] = useState(params.get("regionId") || "-99");
  const [industryId, setIndustryId] = useState(params.get("industryId") || "99");
  const [dealTypeId, setDealTypeId] = useState(params.get("dealTypeId") || "-99");

  function onSubmit(event: FormEvent): void {
    event.preventDefault();
    const next = new URLSearchParams();
    next.set("action", "search");
    if (params.get("sort")) {
      next.set("sort", params.get("sort") || "");
    }
    if (words.trim()) {
      next.set("words", words.trim());
    }
    next.set("firmId", firmId);
    next.set("jurisdiction", jurisdiction);
    next.set("regionId", regionId);
    next.set("industryId", industryId);
    next.set("dealTypeId", dealTypeId);
    setParams(next);
  }

  return (
    <form ref={formRef} className="dealmaker-search" onSubmit={onSubmit}>
      <input name="words" type="search" placeholder="Keyword Search" value={words} onChange={(event) => setWords(event.target.value)} />
      <select value={firmId} onChange={(event) => setFirmId(event.target.value)} aria-label="Select a Firm">
        <option value="-99">Select a Firm</option>
        {(options?.firms ?? []).map((firm) => <option key={firm.id} value={firm.id}>{firm.name}</option>)}
      </select>
      <select value={jurisdiction} onChange={(event) => setJurisdiction(event.target.value)} aria-label="Select a Jurisdiction">
        <option value="-99">Select a Jurisdiction</option>
        {(options?.jurisdictions ?? []).map((item) => <option key={`${item.value}-${item.label}`} value={item.value}>{item.label}</option>)}
      </select>
      <select value={regionId} onChange={(event) => setRegionId(event.target.value)} aria-label="Select a Region">
        <option value="-99">Select a Region</option>
        {(options?.regions ?? []).map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
      </select>
      <select value={industryId} onChange={(event) => setIndustryId(event.target.value)} aria-label="Select an Industry">
        <option value="99">Select an Industry</option>
        {(options?.industries ?? []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
      <select value={dealTypeId} onChange={(event) => setDealTypeId(event.target.value)} aria-label="Select a Deal Type">
        <option value="-99">Select a Deal Type</option>
        {(options?.dealTypes ?? []).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
      <NewButton text="Search" color="primary" style="filled" onClick={() => formRef.current?.requestSubmit()} />
    </form>
  );
}
